// Scene file name constants

export const SCENE_DATA_FILE_NAME = "scene.json";
export const MODELS_FILENAME = "models.json";
export const INFO_JSON_NAME = "info.json";
export const AERO_SCENE_FILE_NAME = "SCENE_JSON";
/** Scene document inside a `.tracex` archive (glTF 2.1). */
export const GLTF_SCENE_FILE_NAME = "scene.gltf";
/** Legacy scene document inside a `.tracex` archive (glXF). Read-only. */
export const GLXF_SCENE_FILE_NAME = "scene.glxf";
/**
 * Archive entries a `.tracex` scene document may use, newest first. Both read
 * forever; only the first is ever written (spec §4, §5).
 */
export const SCENE_DOCUMENT_ARCHIVE_ENTRIES = [GLTF_SCENE_FILE_NAME, GLXF_SCENE_FILE_NAME];
export const SCENE_FILE_NAMES = [
    SCENE_DATA_FILE_NAME,
    MODELS_FILENAME,
    INFO_JSON_NAME,
    ...SCENE_DOCUMENT_ARCHIVE_ENTRIES,
];
